import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { CurrencyProvider } from "./hooks/useCurrency";
import CookieConsent from "@/components/feature/CookieConsent";

function App() {
  useEffect(() => {
    const handleLangChange = (lang: string) => {
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = lang;
    };
    handleLangChange(i18n.language);
    i18n.on('initialized', () => handleLangChange(i18n.language));
    return () => {};
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <CurrencyProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
          <CookieConsent />
        </BrowserRouter>
      </CurrencyProvider>
    </I18nextProvider>
  );
}

export default App;
